<template>
  <fh-ellipsis :content="getNumberValue()" :wrapHeight="params.rowHeight" />
</template>

<script setup>
import { computed } from 'vue';
import { tools } from '@/utils/tools.js';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';

const props = defineProps({
  params: {
    type: Object,
    default: () => {}
  }
});
const fieldsInfo = computed(() => props.params);

const getNumberValue = () => {
  const num = tools.getNumberShow(fieldsInfo.value.fieldValue, fieldsInfo.value.fieldExt);
  const unit = tools.isJSON(fieldsInfo.value.fieldExt) ? JSON.parse(fieldsInfo.value.fieldExt)?.numberUnit : '';
  return unit ? String(num + ' ' + unit) : String(num);
};
</script>
<style scoped lang="less">
@import './number.less';
</style>
